export default function ToleranceHelper(localStorageService) {
    'ngInject';

            const FORCE_OPEN_BOOK_SECTION = 'FORCE_OPEN_BOOK_SECTION';

            return {
                tripPassedWithTolerance,
                tripFailedWithTolerance,
                needToAddToleranceMessage,
                saveAutoOpenBookSection,
                needToOpenBookSectionForTrip,
            };

            function tripPassedWithTolerance(tripResponse) {
                return allItemsPassedTolerance(tripResponse) && hasItemsWithChangedPrice(tripResponse);
            }

            function tripFailedWithTolerance({IsPriceAccepted, BookingResponses, UnavailableProducts}) {
                const bookingResponses = BookingResponses || [];
                const unavailableProducts = UnavailableProducts || [];
                return IsPriceAccepted === false || (!bookingResponses.length && unavailableProducts.length);
            }

            function needToAddToleranceMessage(tripResponse, bookingResponses, tripOptionsService) {
                return tripPassedWithTolerance(tripResponse) && !isEveryItemFailedToBook(bookingResponses, tripOptionsService);
            }

            function allItemsPassedTolerance(tripResponse) {
                return tripResponse.IsPriceAccepted === true;
            }

            function hasItemsWithChangedPrice(tripResponse) {
                return tripResponse.PriceChangedProducts && tripResponse.PriceChangedProducts.length;
            }

            function isEveryItemFailedToBook(bookingResponse, tripOptionsService) {
                return _.every(bookingResponse, function(bookingItem) {
                    return itemNotFailedOrUnconfirmed(bookingItem);
                });

                function itemNotFailedOrUnconfirmed(bookingItem) {
                    return [tripOptionsService.BOOKING_STATUS.Booked,
                            tripOptionsService.BOOKING_STATUS.Unconfirmed].indexOf(bookingItem.BookingStatus) === -1;
                }
            }

            function saveAutoOpenBookSection(tripId) {
                localStorageService.set(FORCE_OPEN_BOOK_SECTION, tripId);
            }

            function needToOpenBookSectionForTrip(tripId) {
                const needToOpen = localStorageService.get(FORCE_OPEN_BOOK_SECTION) === tripId;
                if (needToOpen) {
                    localStorageService.remove(FORCE_OPEN_BOOK_SECTION);
                }
                return needToOpen;
            }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/services/tolerance-helper.factory.js